import React from 'react';

import classNames from 'classnames';

import { InstructionTab, InstructionTabItem } from '../types';

type Props = {
  activeTab: InstructionTab;
  tabs: InstructionTabItem[];
  onChange: (tab: InstructionTab) => void;
};

export const InstructionTabs: React.FC<Props> = ({ activeTab, tabs, onChange }) => (
  <div className="instruction__tabs" role="tablist" aria-label="Подразделы инструкции">
    {tabs.map((tab) => (
      <button
        key={tab.id}
        type="button"
        role="tab"
        aria-selected={activeTab === tab.id}
        className={classNames('instruction__tab', {
          'instruction__tab-active': activeTab === tab.id,
        })}
        onClick={() => onChange(tab.id)}
      >
        {tab.label}
      </button>
    ))}
  </div>
);
